import React from "react";

const EmptyLayout = ({ children }) => {
  return (
    <div className="vh-100 w-full">
      {children}
    </div>
  );
};

export default EmptyLayout;
